// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function GlobeHemisphereWestBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M16 2.5A13.5 13.5 0 1 0 29.5 16 13.515 13.515 0 0 0 16 2.5ZM26.5 16c0 1.148-.189 2.288-.559 3.375l-5.066-3.125a2.456 2.456 0 0 0-.975-.348l-2.852-.384a2.517 2.517 0 0 0-2.333.982h-.509l-.338-.7a2.485 2.485 0 0 0-1.726-1.355l-.335-.07.5-.875h1.8c.422 0 .837-.107 1.207-.311l1.531-.845c.168-.094.325-.207.468-.335l3.364-3.042a2.5 2.5 0 0 0 .823-1.906 10.5 10.5 0 0 1 5 8.939ZM17.595 5.625l.775 1.388-3.026 2.737-1.367.75h-1.96a2.505 2.505 0 0 0-2.17 1.258l-.56.98-.827-2.203 1.239-2.928a10.49 10.49 0 0 1 7.896-1.982ZM5.5 16c0-1.138.186-2.268.55-3.346l.968 2.581a2.486 2.486 0 0 0 1.815 1.566l2.44.525.376.763a2.512 2.512 0 0 0 1.694 1.346l-.626 1.39a2.5 2.5 0 0 0 .448 2.714l.026.027 2.27 2.338-.111.573A10.51 10.51 0 0 1 5.5 16Zm12.956 10.207a2.514 2.514 0 0 0-.625-2.162l-.026-.028-2.215-2.28 1.421-3.19 2.375.32 5.179 3.184a10.525 10.525 0 0 1-6.109 4.157Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
